import company from "@/store/company";
import Vue from "vue";
import {client} from "@/store";

export default {
	namespaced: true,

	state: {
		appointments: [],
		companies: [],
		company: null,
		qualityShowKlanttevredenheid: false,
	},

	// sync actions
	mutations: {
		setCompanies(state, data) {
			const userAgent = navigator.userAgent || navigator.vendor || window.opera;
			let device = "other";
			if (/android/i.test(userAgent)) {
				device = "Android";
			}
			data = data.map(company => {
				if(company.customfield_afspraaktijdstip === "") {
					company.customfield_afspraaktijdstip = null;
				}
				if(company.phone === "") {
					company.phone = null;
				}
				if(company.mobile === "") {
					company.mobile = null;
				}
				company.locationUrl = null;
				if (company.visitingaddress_lat != null && company.visitingaddress_lat.trim() !== "" && company.visitingaddress_lng != null && company.visitingaddress_lng.trim() !== "") {
					// open geo intent on android, otherwise open google maps
					if(device === "Android") {
						company.locationUrl = `geo:?q=${company.visitingaddress_street}+${company.visitingaddress_streetnumber},${company.visitingaddress_zipcode}+${company.visitingaddress_city}`;
					} else {
						company.locationUrl = ` https://maps.google.com/maps?q=${company.visitingaddress_street}+${company.visitingaddress_streetnumber},${company.visitingaddress_zipcode}+${company.visitingaddress_city}`;
					}

				}
				switch (company.gripp_salutation_id) {
					case 1:
						company.salutation = "Dhr.";
						break;
					case 2:
						company.salutation = "Mevr.";
						break;
					default:
						company.salutation = "Dhr / Mevr.";
						break;
				}
				return company;
			});
			state.companies = data;
		},
		setCompany(state, company) {
			const userAgent = navigator.userAgent || navigator.vendor || window.opera;
			let device = "other";
			if (/android/i.test(userAgent)) {
				device = "Android";
			}
			if(company.customfield_afspraaktijdstip === "") {
				company.customfield_afspraaktijdstip = null;
			}
			if(company.phone === "") {
				company.phone = null;
			}
			if(company.mobile === "") {
				company.mobile = null;
			}
			company.locationUrl = null;
			if (company.visitingaddress_lat != null && company.visitingaddress_lat.trim() !== "" && company.visitingaddress_lng != null && company.visitingaddress_lng.trim() !== "") {
				// open geo intent on android, otherwise open google maps
				if(device === "Android") {
					company.locationUrl = `geo:?q=${company.visitingaddress_street}+${company.visitingaddress_streetnumber},${company.visitingaddress_zipcode}+${company.visitingaddress_city}`;
				} else {
					company.locationUrl = ` https://maps.google.com/maps?q=${company.visitingaddress_street}+${company.visitingaddress_streetnumber},${company.visitingaddress_zipcode}+${company.visitingaddress_city}`;
				}

			}
			switch (company.gripp_salutation_id) {
				case 1:
					company.salutation = "Dhr.";
					break;
				case 2:
					company.salutation = "Mevr.";
					break;
				default:
					company.salutation = "Dhr / Mevr.";
					break;
			}
			state.company = company;
		},
		updateCompany(state, data) {
			state.appointments =  state.appointments.reduce((acc, appointment) => {
				if(appointment.hasOwnProperty("company") && appointment.company !== false && appointment.company.id === data.id) {
					appointment.company = data;
				}
				acc.push(appointment);
				return acc;
			}, []);
		},
		setQualityShowKlanttevredenheid(state, data) {
			state.qualityShowKlanttevredenheid = data;
		}
	},

	// async actions
	actions: {
		getCompaniesWithAppointment({
			commit,
			state,
			dispatch
		}, data) {
			const query = `
			query ($date: String, $keywords: String, $ownAppointmentsOnly: Boolean)  {
				companiesWithAppointment(date: $date, keywords: $keywords, ownAppointmentsOnly: $ownAppointmentsOnly) {
					id,
					gripp_salutation_id
					visitingaddress_lat,
					visitingaddress_lng,
					phone,
					mobile,
					visitingaddress_street,
					visitingaddress_streetnumber,
					visitingaddress_zipcode,
					visitingaddress_city,
					companyname,
					customfield_afspraakisolatie,
					customfield_afspraakwoningtype,
					customfield_afspraakdatum,
					customfield_afspraaktijdstip
				}
			}`;

			return new Promise((resolve, reject) => {
				commit("setLoading", null, {root: true});
				client.query(query, {...data}).then(result => {
					commit("setIdle", null, {root: true});
					commit("setCompanies", result.companiesWithAppointment);
					resolve(result.companiesWithAppointment);
				}).catch(error => reject(error));
			});
		},
		getCompany({
			commit,
			state,
			dispatch
		}, data) {
			const query = `
			query ($id: Int!) {
			  company(id: $id) {
				id,
				gripp_salutation_id
				visitingaddress_lat,
				visitingaddress_lng,
				customernumber,
				gripp_accountmanager_id,
				notes,
				email,
				phone,
				mobile,
				visitingaddress_street,
				visitingaddress_streetnumber,
				visitingaddress_zipcode,
				visitingaddress_city,
				companyname,
				customfield_leadkanaal,
				customfield_kmk,
				customfield_dmbron,
				customfield_afspraakbouwjaar,
				customfield_afspraakbuitenmuren,
				customfield_afspraakkruipruimtetoegankelijk,
				customfield_afspraakhoogtekruipruimte,
				customfield_afspraakkruipruimtedroog,
				customfield_afspraakvloerverwarming,
				customfield_afspraakisolatie,
				customfield_afspraakwoningtype,
				customfield_kmkmedewerker,
				customfield_afspraakdatum,
				customfield_afspraaktijdstip,
				customfield_klantaanwezig,
				customfield_leeftijdklant,
				customfield_directverkocht,
				customfield_verkochteproducten,
				customfield_verkoopbedrag,
				customfield_datumaantafel,
				customfield_subsidie,
				customfield_vloergeinspecteerd,
				customfield_opmerkingafspraak,
				customfield_technischnietmogelijk,
				customfield_redennietverkocht
				agent {
					display_name
				},
				kmkReferer {
					id,
					firstname,
					infix,
					lastname
				}
			  }
			}`;

			return new Promise((resolve, reject) => {
				commit("setLoading", null, {root: true});
				client.query(query, {...data}).then(result => {
					commit("setIdle", null, {root: true});
					commit("setCompany", result.company);
					resolve(result.company);
				}).catch(error => reject(error));
			});
		},
		updateCompany({
			commit,
			state,
			dispatch
		}, data) {
			const query = `
			mutation ($id: Int, $customfield_klantaanwezig: String, $customfield_leeftijdklant: String, $customfield_directverkocht: String, $customfield_verkochteproducten: String,
				$customfield_verkoopbedrag: String, $customfield_datumaantafel: String, $customfield_subsidie: String, $customfield_vloergeinspecteerd: String, $customfield_opmerkingafspraak: String,
				$customfield_redennietverkocht: String, $customfield_technischnietmogelijk: String, $isFeedback: Boolean, $isKmk: Boolean)  {
					company: updateCompany(id: $id, customfield_klantaanwezig: $customfield_klantaanwezig, customfield_leeftijdklant: $customfield_leeftijdklant, customfield_directverkocht: $customfield_directverkocht,
						customfield_verkochteproducten: $customfield_verkochteproducten, customfield_verkoopbedrag: $customfield_verkoopbedrag, customfield_datumaantafel: $customfield_datumaantafel, customfield_subsidie: $customfield_subsidie,
						customfield_vloergeinspecteerd: $customfield_vloergeinspecteerd, customfield_opmerkingafspraak: $customfield_opmerkingafspraak, customfield_redennietverkocht: $customfield_redennietverkocht,
						customfield_technischnietmogelijk: $customfield_technischnietmogelijk, isFeedback: $isFeedback, isKmk: $isKmk) {
							id,
							gripp_salutation_id
							visitingaddress_lat,
							visitingaddress_lng,
							customernumber,
							gripp_accountmanager_id,
							notes,
							email,
							phone,
							mobile,
							visitingaddress_street,
							visitingaddress_streetnumber,
							visitingaddress_zipcode,
							visitingaddress_city,
							companyname,
							customfield_leadkanaal,
							customfield_kmk,
							customfield_dmbron,
							customfield_afspraakbouwjaar,
							customfield_afspraakbuitenmuren,
							customfield_afspraakkruipruimtetoegankelijk,
							customfield_afspraakhoogtekruipruimte,
							customfield_afspraakkruipruimtedroog,
							customfield_afspraakvloerverwarming,
							customfield_afspraakisolatie,
							customfield_afspraakwoningtype,
							customfield_kmkmedewerker,
							customfield_afspraakdatum,
							customfield_afspraaktijdstip,
							customfield_klantaanwezig,
							customfield_leeftijdklant,
							customfield_directverkocht,
							customfield_verkochteproducten,
							customfield_verkoopbedrag,
							customfield_datumaantafel,
							customfield_subsidie,
							customfield_vloergeinspecteerd,
							customfield_opmerkingafspraak,
							customfield_technischnietmogelijk,
							customfield_redennietverkocht
							agent {
								display_name
							},
							kmkReferer {
								id,
								firstname,
								infix,
								lastname
							}
						}
			}`;

			return new Promise((resolve, reject) => {
				commit("setLoading", null, {root: true});
				client.query(query, {...data}).then(result => {
					commit("setIdle", null, {root: true});
					commit("updateCompany", result.company);
					resolve(result.company);
				}).catch(error => reject(error));
			});
		},
		getCompaniesWithQualityAppointment({
			commit,
			state,
			dispatch
		}, data) {
			const query = `
			query ($date: String, $keywords: String, $ownAppointmentsOnly: Boolean)  {
				companiesWithQualityAppointment(date: $date, keywords: $keywords, ownAppointmentsOnly: $ownAppointmentsOnly) {
					id,
					gripp_salutation_id
					visitingaddress_lat,
					visitingaddress_lng,
					phone,
					mobile,
					visitingaddress_street,
					visitingaddress_streetnumber,
					visitingaddress_zipcode,
					visitingaddress_city,
					companyname,
					customfield_datumkwaliteitscontrole,
					customfield_kwaliteitbegintijd,
					customfield_kwaliteiteindtijd,
					customfield_kwaliteitmedewerkerid
				}
			}`;

			return new Promise((resolve, reject) => {
				commit("setLoading", null, {root: true});
				client.query(query, {...data}).then(result => {
					commit("setIdle", null, {root: true});
					commit("setCompanies", result.companiesWithQualityAppointment);
					resolve(result.companiesWithQualityAppointment);
				}).catch(error => reject(error));
			});
		},
	}
};
